import { ethers } from 'ethers'
import { LayerZeroV2ABI, LzEndpointABI } from '../abi'
import * as Sumer from '@meterio/sumer-js'

export const getAllLane = async (sumer, { oftAddress }) => {
  const options = {
    abi: LayerZeroV2ABI,
    _sumerProvider: sumer._provider,
  }

  const params = []

  const allLane = await Sumer.eth.read(oftAddress, 'getAllLane', params, options)

  return allLane.map(a => a.toObject())
}

export const getIsShouldEnterTimelock = async (sumer, { oftAddress, params }) => {
  const options = {
    abi: LayerZeroV2ABI,
    _sumerProvider: sumer._provider,
  }

  const tx = await Sumer.eth.read(oftAddress, 'shouldEnterTimelock', params, options)
  return tx
}

export const getQuoteSend = async (sumer, { oftAddress, sendParam }) => {
  const options = {
    abi: LayerZeroV2ABI,
    _sumerProvider: sumer._provider,
  }

  const params = [
    sendParam,
    false
  ]

  const tx = await Sumer.eth.read(oftAddress, 'quoteSend', params, options)
  return tx.toObject()
}

export const signPermit = async (
  signer,
  verifyingContract,
  owner,
  spender,
  value,
  nonce,
  deadline,
  chainId
) => {
  console.log({signer,
    verifyingContract,
    owner,
    spender,
    value,
    nonce,
    deadline,
    chainId})
  const name = "PermitToken";
  const version = "1.0";
  let signature = await signer.signTypedData(
    { name, version, chainId, verifyingContract },
    {
      Permit: [
        { name: "owner", type: "address" },
        { name: "spender", type: "address" },
        { name: "value", type: "uint256" },
        { name: "nonce", type: "uint256" },
        { name: "deadline", type: "uint256" },
      ],
    },
    {
      owner: owner,
      spender: spender,
      value: value,
      nonce: nonce,
      deadline: deadline,
    }
  );
  return signature;
}

export const send = async (sumer, { oftAddress, sendParam, toAddress, shouldEnterTimelock, fee }) => {
  const options = {
    abi: LayerZeroV2ABI,
    _sumerProvider: sumer._provider,
    value: fee.nativeFee,
  }

  const params = [
    sendParam,
    { nativeFee: fee.nativeFee, lzTokenFee: fee.lzTokenFee },
    toAddress,
    shouldEnterTimelock,
  ]

  const tx = await Sumer.eth.trx(oftAddress, 'send', params, options)
  return tx
}

export const sendWithPermit = async (sumer, { oftAddress, sendParam, toAddress, shouldEnterTimelock, fee }) => {

  const { token, amountLD } = sendParam

  const tokenPermit = new ethers.Contract(token, Sumer.abi.ERC20MinterBurnerPauserPermit, sumer._provider)
  const nonce = await tokenPermit.nonces(toAddress);
  const deadline = Math.floor(Date.now() / 1000) + 100;
  const chainId = sumer._network.id;

  const permit = await signPermit(
    sumer._provider,
    token,
    toAddress,
    oftAddress,
    amountLD,
    nonce,
    deadline,
    chainId
  );

  const options = {
    abi: LayerZeroV2ABI,
    _sumerProvider: sumer._provider,
    value: fee.nativeFee,
  }

  const params = [
    sendParam,
    { nativeFee: fee.nativeFee, lzTokenFee: fee.lzTokenFee },
    toAddress,
    shouldEnterTimelock,
    deadline,
    permit.toString(),
  ]

  const tx = await Sumer.eth.trx(oftAddress, 'sendWithPermit', params, options)
  return tx
}

export const executeLzReceive = async (sumer, { LzEndpointAddr, params }) => {
  const options = {
    abi: LzEndpointABI,
    _sumerProvider: sumer._provider,
  }

  const tx = await Sumer.eth.trx(LzEndpointAddr, 'lzReceive', params, options)
  return tx
}
